import SFetch from '@app/utils/sfetch'

export default {
  getSelectorModalAccounts({ range, value, defaultValue, objectLedgerId }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: Silverfin.jsonParams.company_id,
      _options: true,
    }

    const url = Silverfin.Routes.selector_modal_accounts_path(params)
    const body = {
      range,
      value,
      default_value: defaultValue,
      ledger_id: objectLedgerId,
    }

    return SFetch.jsonWithAlert(url, { method: 'POST', body: body })
  },

  getExternalSelectorModalAccounts({
    range,
    value,
    defaultValue,
    objectLedgerId,
    selectedCompanyId,
  }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: Silverfin.jsonParams.company_id,
      _options: true,
    }

    const url = Silverfin.Routes.external_selector_modal_accounts_path(params)

    const body = {
      range,
      value,
      default_value: defaultValue,
      ledger_id: objectLedgerId,
      selected_company_id: selectedCompanyId,
    }

    return SFetch.jsonWithAlert(url, { method: 'POST', body: body })
  },

  updateTextProperties({ updatePath, properties }) {
    return SFetch.jsonWithAlert(updatePath, {
      method: 'POST',
      body: properties,
    })
  },

  getAccountEntries({
    companyId = Silverfin.jsonParams.company_id,
    ledgerId,
    ranges,
    includeZerosValue,
    addRoundingDifference,
    unit,
    precision,
    analyticalDimensionId,
    starred,
  }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      ledger_id: ledgerId,
    }
    const body = {
      include_zeros_value: includeZerosValue,
      analytical_dimension_id: analyticalDimensionId,
      ranges,
      add_rounding_difference: addRoundingDifference,
      unit,
      precision,
      starred,
      _options: true,
    }

    const url = Silverfin.Routes.for_ranges_ledger_account_entries_path(params)
    return SFetch.jsonWithAlert(url, { method: 'post', body })
  },
}
